(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  if(customElements.get('localization-form') === undefined){
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }


      if($(window).width() <= 1200){
        $("localization-form .disclosure").each(function() {
          $(this).find("button.disclosure__button1").remove()
        })
      } 
 
    
  


  
    customElements.define('localization-form', LocalizationForm);
  }  

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["countdown_product_slider"] && !window.DesignMode) return;
  try {
    
  
  var user_input = $(".countdown_product_slider .js-slick-carousel").data("day").split(",");
  var countdown_date,today = new Date();
  var time_diff = 0;
  var days_remaining = 0;
  var hours_remaining = 0;
  var mins_remaining = 0;

  function disp_date(){
    today = new Date();
    countdown_date = new Date(user_input[0] , user_input[1] - 1 , user_input[2] , user_input[3] , user_input[4] , user_input[5]);
    time_diff = Math.floor((countdown_date -  today) / 1000);
    days_remaining = Math.floor(time_diff / 86400);
    hours_remaining = Math.floor((time_diff / 3600) % 24);
    mins_remaining = Math.floor((time_diff / 60) % 60);
    secs_remaining = time_diff % 60;
    // console.log(secs_remaining,mins_remaining,hours_remaining,days_remaining,time_diff,countdown_date);
    setTimeout(disp_date,1000)
  }
  disp_date();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelectorAll('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer_bottom"]) return;
  try {
    
  if(customElements.get('localization-form') === undefined){
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  if($(window).width() <= 1200){
        $("localization-form .disclosure").each(function() {
          $(this).find("button.disclosure__button1").remove()
        })
      } 


  
    customElements.define('localization-form', LocalizationForm);
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    

$(".sf__search-footer-common").parent().on("click",function(){
  $(".mobile_sticky_bar_search > details").attr("open","true");
  $(".mobile_sticky_bar_search").attr("style","z-index:999;display:initial")
})

$(".mobile_sticky_bar_search .icon-close").on("click",function(){
  $(".mobile_sticky_bar_search").attr("style","z-index:0;display:none")
})  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.pr_grid_item')) {
              this.classList.add('product-recommendations--loaded');
            }
            
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 15000px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-backtotop"]) return;
  try {
    

  $(document).ready(function(){
    $(window).scroll(function(){
      if($(window).scrollTop() > 200){
        $("#back_to_top").addClass("active");
      }
      else{
        $("#back_to_top").removeClass("active");
      }
    })
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-tabslider"] && !window.DesignMode) return;
  try {
    

$(document).ready(function($) {
  
   


      function slicktabCarousel(){
          if ($("div.js-slick-carousel").length > 0) {
                    //alert("hi");
                      var slick = $("div.js-slick-carousel");
                      slick.each(function(){
                        
                        var slidestoshow = $(this).data('slidestoshow');
                    	  var slidestoscroll = $(this).data('slidestoscroll');
                        
                        var slidestoshowipadpro = $(this).data('slidestoshowipadpro');
                    	  var slidestoscrollipadpro = $(this).data('slidestoscrollipadpro');
                        
                        var slidestoshowipad = $(this).data('slidestoshowipad');
                    	  var slidestoscrollipad = $(this).data('slidestoscrollipad');
                        
                        var slidestoshowmobile = $(this).data('slidestoshowmobile');
                    	  var slidestoscrollmobile = $(this).data('slidestoscrollmobile');
                        
                        var slidestoshowmobilevertical = $(this).data('slidestoshowmobilevertical');
                    	  var slidestoscrollmobilevertical = $(this).data('slidestoscrollmobilevertical');
                        
                        var rows = $(this).data('rows');
                        var arrows = $(this).data('arrows');
                        var dots = $(this).data('dots');
                        var autoplay = $(this).data('autoplay');
                        var infinite = $(this).data('infinite');
                        var appendDots = $(this).parent().find('.ttrend_append_dots');
                        var settings = {
                              lazyLoad:'ondemand',
                              slidesToShow: slidestoshow,
                              slidesToScroll: slidestoscroll,
                              arrows: arrows,
                              dots: dots,
                              pauseOnHover:true,
                              autoplay: autoplay,
                              autoplaySpeed:'5000',
                              
                              infinite: infinite,
                              appendDots: appendDots,
                        		responsive: [
                                	{
                                      breakpoint: 1400,
                                      settings: {
                                          dots: dots,
                                          arrows: arrows,
                                          infinite: infinite,
                                        	autoplay: autoplay,
                                          slidesToShow: slidestoshowipadpro,
                                          slidesToScroll: slidestoscrollipadpro
                                      }
                                  },
                                  {
                                      breakpoint: 1024,
                                      settings: {
                                          dots: dots,
                                          arrows: arrows,
                                          infinite: infinite,
                                        	autoplay: autoplay,
                                          slidesToShow: slidestoshowipad,
                                          slidesToScroll: slidestoscrollipad
                                      }
                                  },
                                  {
                                      breakpoint: 767,
                                      settings: {
                                          dots: dots,
                                          arrows: arrows,
                                        	autoplay:autoplay,
                                          infinite: infinite,
                                          slidesToShow: slidestoshowmobile,
                                          slidesToScroll: slidestoscrollmobile
                                      }
                                  },
                                	{
                                      breakpoint: 480,
                                      settings: {
                                          dots: dots,
                                          arrows: arrows,
                                        	autoplay:autoplay,
                                          infinite: infinite,
                                          slidesToShow: slidestoshowmobilevertical,
                                          slidesToScroll: slidestoscrollmobilevertical
                                      }
                                  }
                                
                              ]
                        };
                        	
                        if(rows){
                          $.extend(settings, {
                              rows: rows,
                          });
                        }
                        
                        $(this).slick(settings);
                                
                      })
                     }
      
      }

    $(".tab_content").hide();
	$(".tab_content:first").show(); 

	$("ul.tabs li").click(function() {
		$("ul.tabs li").removeClass("active");
		$(this).addClass("active");
		$(".tab_content").hide();
		$(".tab_content").removeClass("animate1");
		var activeTab = $(this).attr("rel"); 
		$("#"+activeTab).addClass("animate1");
		$("#"+activeTab).fadeIn();
      setTimeout(slicktabCarousel,2000)
	});
  

});
  

  } catch(e) { console.error(e); }
})();
      })();
